import apiClient from '../api';

export const getPairStats = (teamId) =>
    apiClient.get('/pair-stats', { params: { teamId } }).then(r => r.data);

export const getPlayerStreaks = (teamId) =>
    apiClient.get('/player-streaks', { params: { teamId } }).then(r => r.data);

export const getPlayerPerformance = (playerId) =>
    apiClient.get(`/players/${playerId}/performance`).then(r => r.data);
